export default __webpack_public_path__ + "static/media/weezticket-logo.20a99fb9.png";